import axios from "axios";
import { Promise } from "true-promise";
const convertOuverturePeriode = (op) => !op ? null : ({
    Start: op.Start ? new Date(op.Start) : null,
    End: op.End ? new Date(op.End) : null,
    Length: op.Length ? parseInt(op.Length) : null
});
export function requestItems(url, filter_id) {
    return new Promise((resolve, reject) => {
        axios.get(`https://${url}/api/smallitems?id=${filter_id}`)
            .then(response => {
            const smallItems = response.data.items;
            const requests = smallItems.map(si => axios.get(`https://${url}/api/item?id=${si.ExternalId}`));
            Promise.allSettled(requests)
                .then((responses) => {
                const items = responses
                    .filter((response) => response.status === "resolved")
                    .map(response => response.value.data)
                    .map(item => ({
                    ...item,
                    OuverturePeriodes: item.OuverturePeriodes.map(convertOuverturePeriode),
                    NextOuverturePeriode: convertOuverturePeriode(item.NextOuverturePeriode),
                    LastModified: item.LastModified ? new Date(item.LastModified) : null,
                }));
                resolve(items);
            });
        })
            .catch(reject);
    });
}
